import "./rangeInputs";
import { run } from "./swiper";

const ANIMATION_DURATION = 1000;
const ANIMATION_DELAY = 15000;
const SLIDER_ANIMATION_CLASS = "slider__description-active";
const TABS_ACTIVE_CLASS = "slider__tabs-btn--active";
const $descriptionList = document.querySelector(".slider__description");
const $descriptions = $descriptionList?.querySelectorAll(".slider__description-item");
$descriptionList.style.setProperty("--animation-duration", `${ANIMATION_DURATION / 1000}s`);
const $tabsButtons = document.querySelectorAll(".slider__tabs .slider__tabs-btn");

// HELPERS
function clearClasses($elementsList: any, realIndex: number, elemClass: string) {
  $elementsList?.forEach((i: Element, index: number) => {
    if (index === realIndex) return;
    i.classList.remove(elemClass);
  });
}

function addClass($list: any, index: number, cssClass: string) {
  const tab = $list?.[index];
  if (!tab) return;
  clearClasses($list, index, cssClass);
  tab.classList.add(cssClass);
}

function getRedirectUrl(path: string): string {
  return `${window.location.origin}/login/?redirectPath=${encodeURIComponent(path)}`;
}

// SLIDER
const swiper = run({
  speed: ANIMATION_DURATION,
  autoplay: {
    delay: ANIMATION_DELAY,
    disableOnInteraction: false,
  },
  on: {
    init: function() {
      addClass($descriptions, this.realIndex, SLIDER_ANIMATION_CLASS);
    },
  },
});

let replicaDetector: null | number = null;
swiper.on("slideChange", function() {
  if (replicaDetector === swiper.realIndex) return;

  addClass($descriptions, swiper.realIndex, SLIDER_ANIMATION_CLASS);
  addClass($tabsButtons, swiper.realIndex, TABS_ACTIVE_CLASS);

  replicaDetector = swiper.realIndex;
});

$tabsButtons?.forEach(i => {
  i.addEventListener("click", function(evt) {
    i.classList.add(TABS_ACTIVE_CLASS);
    swiper.slideTo(+evt.target?.dataset?.slideIndex ?? 0, 0);
    clearClasses($tabsButtons, swiper.realIndex, TABS_ACTIVE_CLASS);
  });
});

// REDIRECT to Become a creator
const REDIRECT_PATH = "/more/payeeInfo";
const $redirectButtons = document.querySelectorAll(".js-redirect");

$redirectButtons.forEach(i => {
  i.addEventListener("click", evt => {
    evt.preventDefault();
    window.location = getRedirectUrl(REDIRECT_PATH);
  });
});
